import React from "react";
import { Grid } from "@material-ui/core";
import AnyChart from 'anychart-react'
import anychart from "anychart";
import { MapContainer, TileLayer, Polygon, Tooltip} from "react-leaflet";
const { Component } = React;

export default class ZonedMap extends Component {

  constructor(props) {
    super(props);
    this.center = props.center;
    this.selectZone = props.selectZone
    this.chart = anychart.gauges.linear();

    this.chart.padding([25, 5, 35, 15]);
    this.chart.tooltip(false);
    this.chart.layout('vertical')

    this.chart
      .title()
      .enabled(false);
  }

  generateChart(zoneSelected, data) {

    var ranges = data.colorRanges
    var total = data.total

    var markValue = null;

    data.zones.forEach((zone) => {
      if (zone.id === zoneSelected) {
        markValue = zone.count
      }
    });

    if (markValue != null)
      this.chart.data([markValue]);
    else
      this.chart.data([]);

    var width = "20%"
    this.chart
      .scaleBar(0)
      .width(width)
      .from(0)
      .to(ranges[0])
      .fill({
        keys: ["white"],
        opacity: 0.8,
        angle: 90
      });

    this.chart
      .scaleBar(1)
      .width(width)
      .from(ranges[0])
      .to(ranges[1])
      .fill({
        keys: ["white","yellow"],
        opacity: 0.8,
        angle: 90
     });

    this.chart
      .scaleBar(2)
      .width(width)
      .from(ranges[1])
      .to(ranges[2])
     .fill({
        keys: ["yellow","red"],
        opacity: 0.8,
        angle: 90
      });

    this.chart
      .scaleBar(3)
      .width(width)
      .from(ranges[2])
      .to(ranges[3])
      .fill({
        keys: ["red"],
        opacity: 0.8,
        angle: 90
      });

    var scale = this.chart.scale();
    scale.minimum(ranges[0]).maximum(ranges[2]).ticks(ranges);

    var axis = this.chart.axis();
    axis.width('0.5%').offset('0%').scale(scale);
    axis.labels().fontSize(12).format(function () {
      return Math.round((this.value/total)*100).toLocaleString() + "%";
    });
    
    var marker = this.chart.marker();
    marker.color('black').offset('20%').type('triangle-left');

    marker
      .labels()
      .enabled(true)
      .position('right-center')
      .anchor('left-center')
      .fontSize(10)
      .fontColor('black')
      .format(function() {
         return Math.round((this.value/total)*100).toLocaleString() + "%";
      });


    this.chart.container('mapColorRangeChart');

    this.chart.draw();

    return this.chart;
  }

  render() {
    return (
      <Grid container style={{height: "100%"}}>
        <Grid item xs={10} style={{height: "100%"}}>
          <MapContainer
            style={{
              height: "100%",
              width: "100%"
            }}
            center={this.center}
            zoom={14}
            scrollWheelZoom={true}>

            { this.props.data != null && this.props.data.zones.map((zone) => (
              <Polygon
                key={zone.id} 
                positions={zone.coordinates} 
                fillColor={zone.color}
                fillOpacity={0.65}
                color="#000000"
                weight={2}
                opacity={1}
                eventHandlers={{
                  click: () => {
                    this.selectZone(zone.id)
                  },
                }}>
                <Tooltip>{zone.name}</Tooltip>
              </Polygon> 
            ))}

            { this.props.data != null && this.props.data.zones.map((zone) => (
              <div key={-zone.id}>
                { this.props.hihglightZone === zone.id ? (
                    <Polygon
                      positions={zone.coordinates} 
                      fillColor={zone.color}
                      fillOpacity={0}
                      color="#000000"
                      weight={4}
                      opacity={1}
                      eventHandlers={{
                        click: () => {
                          this.selectZone(zone.id)
                        },
                      }}>
                      <Tooltip>{zone.name}</Tooltip>
                    </Polygon>
                  ) : (null)
                }
              </div>
            ))}

            <TileLayer
                attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
          </MapContainer>
        </Grid>
        <Grid item xs={2} style={{height:"100%"}} className="chart-container">
            <AnyChart 
              id="mapColorRangeChart"
              intance={ this.props.data != null ? this.generateChart(this.props.hihglightZone,this.props.data) : null } />
        </Grid>
      </Grid>
    )
  }

}
